export const SET_MESSAGE = 'SET_MESSAGE'
export const SET_TARGET = 'SET_TARGET'

type State = {
    message: string
    target: string
}

type SetMessageAction = {
    type: typeof SET_MESSAGE
    payload: string
}

type SetTargetAction = {
    type: typeof SET_TARGET
    payload: string
}
type Action = SetMessageAction | SetTargetAction

export const selectedAmountReducer = (state: State, action: Action) => {
    switch (action.type) {
        case SET_MESSAGE:
            return { ...state, message: action.payload }
        case SET_TARGET:
            return { ...state, target: action.payload }
        default:
            return state
    }
}
